import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Home from "./Home";
import Services from "./Services";
import Blog from "./Blog";
import Career from "./Career";
import Contact from "./Contact";
import Aboutus from "./Aboutus";
import Product from "./Product";
import BlogDetail from "./BlogDetail";
import QRCodeGenerator from "./QRCodeGenerator";
import Error404 from "./Error404";
import ClientProjects from "./ClientProjects";

const RouterContainer = () => {
  const PageOpenFromTop = () => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  };

  return (
    <>
      <BrowserRouter>
        <PageOpenFromTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/About-us" element={<Aboutus />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/Career" element={<Career />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Product" element={<Product />} />
          <Route path="/QRCodeGenerator" element={<QRCodeGenerator />} />
          <Route path="/projects" element={<ClientProjects />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RouterContainer;
